import { rem } from 'polished'
import { useCallback } from 'react'
import styled from 'styled-components'

import SelectItemToAdd from '../TripModal/TripItems/SelectItemToAdd'

import { addToTripClickEvent } from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import Clickable from 'components/Common/Clickable'
import IconButton from 'LuxKit/Button/IconButton'
import SolidPlusIcon from 'LuxKit/Icons/solid/SolidPlusIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import { horizontalChildSpacing } from 'components/utils/spacing'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

const Root = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  padding: ${rem(16)} ${rem(20)};

  @container (min-width: 640px) {
    padding: ${rem(12)} ${rem(40)};
  }

  @media print {
    display: none;
  }
`

const AddToTripCallAction = styled(Clickable)`
  display: flex;
  align-items: center;

  ${horizontalChildSpacing[12]};
`

interface Props {
  tripId: string
  label?: string
  date: string
}

function TimelineAddButton(props: Props) {
  const { tripId, date, label } = props

  const openModal = useOpenModal()

  const onAddToTrip = useCallback(() => {
    fireInteractionEvent(addToTripClickEvent('button', 'itinerary_timeline'))
    openModal(SelectItemToAdd, { tripId, defaultDate: date })
  }, [openModal, date, tripId])

  return (
    <Root>
      <AddToTripCallAction onClick={onAddToTrip}>
        <div>
          <IconButton
            kind="primary"
            shape="circle"
            nonInteractable
            size="small"
          >
            <SolidPlusIcon colour="neutral-eight" />
          </IconButton>
        </div>
        {label && (
          <BodyText variant="large" colour="neutral-two">
            {label}
          </BodyText>
        )}
      </AddToTripCallAction>
    </Root>
  )
}

export default TimelineAddButton
